<hr />
<div class="container" [ngClass]="{ 'container-extension': open }">
  <div class="flex justify-between items-center">
    <div class="flex items-center">
      <div class="icon flex items-center justify-center">
        <svg-icon (click)="toggleAll()" key="{{ open ? 'less' : 'add' }}" class="cursor-pointer" size="{{ open ? 'md' : 'xl' }}"></svg-icon>
      </div>
      <h3 class="mx-6 title">{{ title }}</h3>
    </div>
  </div>
  <div id="content" *ngIf="open" class="content">
    <ng-content></ng-content>
  </div>
</div>
<hr />
